const ClosureSurveyData = {}

export default ClosureSurveyData
